module.exports = __webpack_public_path__ + "static/media/move-to-conv.b1b33510.svg";